export const LIST_REGIONAL_REQUEST = 'LIST_REGIONAL_REQUEST'
export const LIST_REGIONAL_SUCCESS = 'LIST_REGIONAL_SUCCESS'
export const LIST_REGIONAL_FAILURE = 'LIST_REGIONAL_FAILURE'

export const LIST_REGIONAL_SUMMARY_REQUEST = 'LIST_REGIONAL_SUMMARY_REQUEST'
export const LIST_REGIONAL_SUMMARY_SUCCESS = 'LIST_REGIONAL_SUMMARY_SUCCESS'
export const LIST_REGIONAL_SUMMARY_FAILURE = 'LIST_REGIONAL_SUMMARY_FAILURE'

export const CREATE_REGIONAL_REQUEST = 'CREATE_REGIONAL_REQUEST'
export const CREATE_REGIONAL_SUCCESS = 'CREATE_REGIONAL_SUCCESS'
export const CREATE_REGIONAL_FAILURE = 'CREATE_REGIONAL_FAILURE'

export const DETAIL_REGIONAL_REQUEST = 'DETAIL_REGIONAL_REQUEST'
export const DETAIL_REGIONAL_SUCCESS = 'DETAIL_REGIONAL_SUCCESS'
export const DETAIL_REGIONAL_FAILURE = 'DETAIL_REGIONAL_FAILURE'

export const UPDATE_REGIONAL_REQUEST = 'UPDATE_REGIONAL_REQUEST'
export const UPDATE_REGIONAL_SUCCESS = 'UPDATE_REGIONAL_SUCCESS'
export const UPDATE_REGIONAL_FAILURE = 'UPDATE_REGIONAL_FAILURE'

export const DELETE_REGIONAL_REQUEST = 'DELETE_REGIONAL_REQUEST'
export const DELETE_REGIONAL_SUCCESS = 'DELETE_REGIONAL_SUCCESS'
export const DELETE_REGIONAL_FAILURE = 'DELETE_REGIONAL_FAILURE'
